/**
 * tcm-v1 欄位中文標籤對照表
 * 
 * 將技術性欄位名稱（siteConfig.siteName）轉換為友善的中文標籤
 * 用於後台編輯介面顯示
 */

export const FIELD_LABELS: Record<string, string> = {
  // siteConfig
  "siteConfig.siteName": "診所名稱",
  "siteConfig.doctorName": "醫師姓名",
  "siteConfig.doctorTitle": "醫師職稱",
  "siteConfig.whatsappNumber": "WhatsApp 號碼",
  "siteConfig.whatsappDefaultMessage": "WhatsApp 預設訊息",
  "siteConfig.whatsappInquiryMessage": "WhatsApp 查詢訊息",
  "siteConfig.phone": "電話",
  "siteConfig.address": "地址",
  "siteConfig.addressDetail": "地址詳情",
  "siteConfig.registrationNumber": "註冊編號",
  "siteConfig.socialLinks.facebook": "Facebook 連結",
  "siteConfig.socialLinks.youtube": "YouTube 連結",

  // navigationContent
  "navigationContent.links": "導覽連結",
  "navigationContent.ctaText": "CTA 按鈕文字",

  // heroContent
  "heroContent.heading": "主標題",
  "heroContent.subheading": "副標題",
  "heroContent.tagline": "標語",
  "heroContent.primaryCta.text": "主按鈕文字",
  "heroContent.primaryCta.message": "主按鈕 WhatsApp 訊息",
  "heroContent.secondaryCta.text": "次按鈕文字",
  "heroContent.secondaryCta.href": "次按鈕連結",
  "heroContent.trustBadges": "信任徽章",
  "heroContent.backgroundImage": "背景圖片",

  // aboutContent
  "aboutContent.sectionTitle": "區塊標題",
  "aboutContent.sectionSubtitle": "區塊副標題",
  "aboutContent.timelineTitle": "時間軸標題",
  "aboutContent.timeline": "學經歷時間軸",
  "aboutContent.philosophyTitle": "理念標題",
  "aboutContent.philosophyCards": "理念卡片",
  "aboutContent.doctorImage": "醫師照片",
  "aboutContent.doctorImageAlt": "醫師照片 Alt 文字",

  // tcmIntroContent
  "tcmIntroContent.sectionTitle": "區塊標題",
  "tcmIntroContent.sectionSubtitle": "區塊副標題",
  "tcmIntroContent.contentTitle": "內容標題",
  "tcmIntroContent.content": "內容",
  "tcmIntroContent.highlights": "亮點",

  // servicesContent
  "servicesContent.sectionTitle": "區塊標題",
  "servicesContent.sectionSubtitle": "區塊副標題",
  "servicesContent.services": "診療項目",
  "servicesContent.processTitle": "流程標題",
  "servicesContent.processSubtitle": "流程副標題",
  "servicesContent.processSteps": "流程步驟",

  // galleryContent
  "galleryContent.sectionTitle": "區塊標題",
  "galleryContent.sectionSubtitle": "區塊副標題",
  "galleryContent.disclaimer": "免責聲明",
  "galleryContent.items": "照片項目",

  // faqContent
  "faqContent.sectionTitle": "區塊標題",
  "faqContent.sectionSubtitle": "區塊副標題",
  "faqContent.items": "常見問題",

  // healthBlogContent
  "healthBlogContent.sectionTitle": "區塊標題",
  "healthBlogContent.description": "描述",
  "healthBlogContent.comingSoonText": "即將推出文字",
  "healthBlogContent.ctaText": "CTA 文字",

  // contactContent
  "contactContent.sectionTitle": "區塊標題",
  "contactContent.sectionSubtitle": "區塊副標題",
  "contactContent.ctaText": "CTA 文字",
  "contactContent.transport.title": "交通資訊標題",
  "contactContent.transport.description": "交通資訊描述",
  "contactContent.transport.busInfo": "巴士資訊",
  "contactContent.clinicHours": "門診時間",
  "contactContent.hoursNote": "時間備註",
  "contactContent.mapEmbedUrl": "地圖嵌入 URL",

  // footerContent
  "footerContent.brandSlogan": "品牌標語",
  "footerContent.quickLinks": "快速連結",
  "footerContent.socialLinks": "社群連結",
  "footerContent.disclaimer": "免責聲明",
};

/**
 * 取得欄位的中文標籤
 * @param path 欄位路徑，例如 "siteConfig.siteName"
 * @returns 中文標籤，若無對應則返回原始路徑的最後一段
 */
export function getFieldLabel(path: string): string {
  if (FIELD_LABELS[path]) {
    return FIELD_LABELS[path];
  }
  
  // 若無對應，返回最後一段並轉為友善格式
  const lastPart = path.split(".").pop() || path;
  return lastPart
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
}
